module.exports = __webpack_public_path__ + "img/closed_btn.7612cc27.png";